<div class="modal-backdrop">
  <div class="modal-content discount-modal">
    <button class="close-btn" (click)="close.emit()">&times;</button>
    <div class="modal-body">
      <div class="modal-left">
        <h2>SAVE 15% ON YOUR SHIPPING FEE</h2>
        <p class="subtitle">just for you!</p>
        <div class="discount-code-box" (click)="copyToClipboard('BACK15')">
          <input type="text" value="BACK15" readonly />
          <button class="copy-btn" >
            <span class="material-icons">content_copy</span>
          </button>
        </div>
        <button class="continue-btn" (click)="close.emit()">CONTINUE SHOPPING</button>
      </div>
      <div class="modal-right">
        <img src="https://d1we2hgzmci25y.cloudfront.net/assets/img/exit_intent_fregiht_forwarder.webp" alt="Shipping Discount" />
      </div>
    </div>
  </div>
</div> 